module.exports = __webpack_public_path__ + "static/bbc_main_logo-c097ff4e76811d36642ce29693a2f041.png";